import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { CMS_LOGIN_PATH, canAccessCms, getToken, removeUserSession } from './index';

// handle the private routes for CMS
function CmsPrivateRoute({ component: Component, ...rest }) {
    const allowed = canAccessCms();
    if (!allowed && getToken()) {
        removeUserSession();
    }
    return (
        <Route
            {...rest}
            render={(props) =>
                allowed
                    ? <Component {...props} />
                    : <Redirect to={{ pathname: CMS_LOGIN_PATH, state: { from: props.location } }} />
            }
        />
    )
}

export default CmsPrivateRoute;
